import * as React from 'react';

import { IconColors } from '../../Icons';
import { IconProps } from '../../Icons/IconProps';
import styles from './icon-with-text.module.css';
import { IconWithTextDefaultsContext } from './iconWithTextDefaults';

interface IconWithTextProps {
    text: string;
    textSize?: string;
    Icon: React.FC<IconProps>;
    iconAspect?: string;
    iconOnLeft?: boolean;
    color?: IconColors;
    style?: React.CSSProperties;
    wrapText?: boolean;
}

const IconWithText: React.FC<IconWithTextProps> = ({
    text,
    textSize,
    Icon,
    iconAspect,
    iconOnLeft = false,
    color,
    style = {},
    wrapText = false,
}) => {
    const defaults = React.useContext(IconWithTextDefaultsContext);

    const resolvedColor = color ?? defaults.color ?? IconColors.Action;
    const resolvedTextSize = textSize ?? defaults.textSize ?? '.75rem';
    const resolvedIconAspect = iconAspect ?? defaults.iconAspect ?? '1.2rem';

    const textStyle = {
        color: resolvedColor,
        fontSize: resolvedTextSize,
        ...(wrapText ? { whiteSpace: 'normal' as const } : {}),
    };

    return (
        <div
            className={`${styles.IconWithText}${defaults.compact ? ` ${styles.Compact}` : ''}`}
            style={style}
            data-qa={`icon-with-text-${text}`}
        >
            {iconOnLeft ? (
                <>
                    <Icon color={resolvedColor} aspect={resolvedIconAspect} style={{ minWidth: resolvedIconAspect }} />
                    <p className={styles.IconOnLeft} style={textStyle}>
                        {text}
                    </p>
                </>
            ) : (
                <>
                    <p className={styles.IconOnRight} style={textStyle}>
                        {text}
                    </p>
                    <Icon color={resolvedColor} aspect={resolvedIconAspect} style={{ minWidth: resolvedIconAspect }} />
                </>
            )}
        </div>
    );
};

export default IconWithText;
